// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { getProductsForShopifyVariants } from "./schema/get-products-for-shopify-variants";
import { updateVariantListingImages } from "./schema/listing-images/update-variant-listing-images";
import { disableListing } from "./schema/listing-management/disable-listing";
import { enableListing } from "./schema/listing-management/enable-listing";

export const groupG = {
  updateVariantListingImages,
  disableListing,
  enableListing,
  getProductsForShopifyVariants,
};
